import gql from 'graphql-tag';

export const PersistentInviteEligibleQuery = gql`
	query PersistentInviteEligibleQuery(
		$spaceKey: String
		$skipLicenseQuery: Boolean!
		$skipSpaceQuery: Boolean!
	) {
		space(key: $spaceKey) @skip(if: $skipSpaceQuery) {
			id
			currentUser {
				isAnonymouslyAuthorized
			}
		}
		license @skip(if: $skipLicenseQuery) {
			licenseConsumingUserCount
			trialEndDate
		}
	}
`;
